<template>

  <div class="card">
    <div v-if="!readonly" class="card-toolbar">
      <div class="main-actions">
          <button v-if="!readonly" class="main-btn main-btn-success" data-bs-toggle="modal"
                title="Novo Pedido" :data-bs-target="'#modal_store_exam_request_' + modalRecordId"
                @click="resetCreateForm">
            <i class="bi bi-plus-lg"></i>
            <span>Novo Pedido</span>
          </button>
      </div>
    </div>

    <div v-if="examRequests.length === 0" class="empty-state">
      <div class="empty-state-content">
        <div class="empty-state-icon">
          <svg xmlns="http://www.w3.org/2000/svg" width="80" height="80" viewBox="0 0 24 24" fill="none">
            <path opacity="0.3" d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="#780f5a"/>
            <path d="M14 2V8H20L14 2ZM18 20H6V4H13V9H18V20Z" fill="#780f5a"/>
            <path d="M12 14H8V16H12V14ZM16 10H8V12H16V10ZM8 6H16V8H8V6Z" fill="#780f5a"/>
          </svg>
        </div>
        <h3 class="empty-state-title">Nenhum exame</h3>
        <p class="empty-state-description" v-if="!readonly">
          Ainda não foi adicionado nenhum exame para este atendimento.<br>
          Clique no botão "Novo Pedido" acima para começar.
        </p>
      </div>
    </div>

    <div class="exam-card" v-for="examRequest in examRequests" :key="examRequest.id_exam_request">
      <div class="exam-header collapsible cursor-pointer rotate"
           data-bs-toggle="collapse" :data-bs-target="'#kt_exam_request_card_collapsible_' + documentDomId(examRequest.id_exam_request)">
        <div class="exam-title">
          <div class="exam-icon">
            <span class="svg-icon svg-icon-2">
              <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                <path opacity="0.3" d="M14 2H6C4.9 2 4 2.9 4 4V20C4 21.1 4.9 22 6 22H18C19.1 22 20 21.1 20 20V8L14 2Z" fill="currentColor"/>
                <path d="M14 2V8H20L14 2ZM18 20H6V4H13V9H18V20Z" fill="currentColor"/>
              </svg>
            </span>
          </div>
          <div class="exam-info">
            <h3 class="exam-name">#{{examRequest.id_exam_request}} {{examRequest?.exam_request_name}}</h3>
            <span v-if="examRequest.id_task_origin" class="badge bg-light-primary text-primary">Emissão avulsa · Tarefa #{{ examRequest.id_task_origin }}</span>
            <div class="exam-status">
              <span :title="examRequest.exam_request_generated?'Alteração bloqueada - PDF já gerado':'Liberado para alteração'" 
                    :class="examRequest.exam_request_generated?'status-icon locked':'status-icon unlocked'">
                <i :class="examRequest.exam_request_generated?'bi bi-lock-fill':'bi bi-unlock-fill'"></i>
              </span>
              <span v-if="examRequest.exam_request_generated" title="PDF gerado" class="status-icon pdf">
                <i class="bi bi-file-pdf-fill"></i>
              </span>
              <span v-if="examRequest.exam_request_signed" title="Assinado" class="status-icon signed">
                <i class="bi bi-pen-fill"></i>
              </span>
            </div>
          </div>
        </div>
        <div class="exam-toolbar rotate-180">
          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="11" y="18" width="13" height="2" rx="1" transform="rotate(-90 11 18)" fill="currentColor"></rect>
              <path d="M11.4343 15.4343L7.25 11.25C6.83579 10.8358 6.16421 10.8358 5.75 11.25C5.33579 11.6642 5.33579 12.3358 5.75 12.75L11.2929 18.2929C11.6834 18.6834 12.3166 18.6834 12.7071 18.2929L18.25 12.75C18.6642 12.3358 18.6642 11.6642 18.25 11.25C17.8358 10.8358 17.1642 10.8358 16.75 11.25L12.5657 15.4343C12.2533 15.7467 11.7467 15.7467 11.4343 15.4343Z" fill="currentColor"></path>
            </svg>
          </span>
        </div>
      </div>
      <div :id="'kt_exam_request_card_collapsible_' + documentDomId(examRequest.id_exam_request)" class="collapse show">
        <div class="exam-actions">
          <div class="action-buttons">
            <button v-if="!readonly && examRequest.exam_request_generated" class="action-btn action-btn-warning action-btn-reopen"
                    title="Reabrir para Alteração" @click="reopenExamRequest(examRequest.id_exam_request)">
              <i class="bi bi-unlock-fill"></i>
              <span>Reabrir</span>
            </button>
            <button class="action-btn action-btn-info action-btn-print"
                    title="Imprimir" @click="showSelectCertifier(examRequest)">
              <i class="bi bi-printer"></i>
              <span>{{ taskContext ? 'Emitir / assinar' : 'Imprimir' }}</span>
            </button>
            <button v-if="!readonly" class="action-btn action-btn-secondary" data-bs-toggle="modal"
                    :data-bs-target="'#modal_save_exam_model_' + modalRecordId"
                    title="Salvar este pedido como modelo"
                    @click="openSaveAsModel(examRequest)">
              <i class="bi bi-bookmark-plus"></i>
              <span>Salvar</span>
            </button>
            <button v-if="!readonly" class="action-btn action-btn-danger action-btn-delete"
                    title="Excluir Pedido" @click="deleteExamRequest(examRequest.id_exam_request)">
              <i class="bi bi-trash"></i>
              <span>Excluir</span>
            </button>
          </div>
        </div>
        <div class="card-body">
          <div v-if="examRequest.exam_request_obs" class="exam-request-obs">
            <i class="bi bi-chat-left-text"></i>
            <span>{{ examRequest.exam_request_obs }}</span>
          </div>
          <ExamRequestItems :schedule="schedule" :examRequest="examRequest" :key="examRequest.id_exam_request" :readonly="readonly"></ExamRequestItems>
        </div>
      </div>

      <Teleport to="body">
<div class="modal fade" data-bs-backdrop="static" data-bs-keyboard="false"
           :id="'modal_print_exam_' + documentDomId(examRequest.id_exam_request)" tabindex="-1">
        <div class="modal-dialog modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header" v-if="messagesGenerateExam.showBtnClose">
              <div class="btn btn-icon btn-sm btn-active-light-primary ms-2"
                   data-bs-dismiss="modal" aria-label="Fechar">
                <i class="bi bi-x-lg"></i>
              </div>
            </div>
            <div class="modal-body">
              <div class="col-md-12 mb-6 mt-4">
                <div class="text-center px-5" :key="messagesGenerateExam.image">
                  <video width="200" height="200" :loop="messagesGenerateExam.loop"  autoplay playsinline muted v-if="messagesGenerateExam.image.includes('.mp4')">
                    <source :src="messagesGenerateExam.image" type="video/mp4" />
                  </video>
                  <img v-else-if="messagesGenerateExam.image" :src="messagesGenerateExam.image" alt="Imagem" class="mw-100 h-200px h-sm-325px">
                  <p v-html="messagesGenerateExam.message"></p>
                </div>
              </div>
            </div>
            <div class="modal-footer" v-if="messagesGenerateExam.showBtnClose">
              <button type="button" class="btn btn-light" data-bs-dismiss="modal">Fechar</button>
            </div>
          </div>
        </div>
      </div>
  </Teleport>
    </div>
  </div>

  <Teleport to="body">
  <div ref="createModal" class="modal fade prescription-create" tabindex="-1" data-bs-focus="false" data-bs-backdrop="false"
       @click.self="closeCreateModal"
       :aria-labelledby="'exam_request_create_title_' + modalRecordId" :id="'modal_store_exam_request_' + modalRecordId">
    <div class="modal-dialog modal-xl modal-dialog-centered modal-dialog-scrollable">
      <form method="post" @submit.prevent="submitFormStore">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" :id="'exam_request_create_title_' + modalRecordId">Novo Pedido de Exame</h5>
            <button type="button" class="prescription-create__chip prescription-create__close" data-bs-dismiss="modal" aria-label="Fechar">
              <i class="bi bi-x-lg"></i>
            </button>
          </div>
          <div class="modal-body">
            <p v-if="taskContext" class="alert alert-primary py-3"><strong>{{ taskContext.patientName }}</strong> · Emissão avulsa vinculada ao atendimento de {{ taskContext.recordDate }}.</p>
            <div class="d-flex flex-wrap gap-2 mb-4">
              <button type="button" class="prescription-create__chip" :class="{ 'is-active': !fromPrevious }" :aria-pressed="!fromPrevious" @click="fromPrevious = false">Em branco ou modelo</button>
              <button type="button" class="prescription-create__chip" :class="{ 'is-active': fromPrevious }" :aria-pressed="fromPrevious" @click="fromPrevious = true">A partir de consulta anterior</button>
            </div>
            <PreviousDocumentPicker v-if="fromPrevious" agenda-style :professional-id="schedule.id_prof" :patient-id="schedule.id_patient"
              :record-id="medicalRecord.id_medrec" :task-context="taskContext" kind="exam-requests" @created="onPreviousCopied" @empty="fromPrevious = false" />
            <template v-else>
              <div class="col-md-12 mb-4">
                <label :for="'exam_protocol_store_' + modalRecordId" class="form-label">Modelo de pedido</label>
                <SelectUbbi :id="'exam_protocol_store_' + modalRecordId"
                            v-model="formStore.id_exam_prot"
                            :options="[{ id_exam_prot: '', exam_prot_name: 'Em branco' }, ...(examProtocols || [])]"
                            option-label="exam_prot_name" option-value="id_exam_prot"
                            placeholder="Em branco" searchable @change="onModelChange" />
              </div>
              <DraftExamComposer ref="examComposer" v-model="draftExams"/>
              <div class="col-md-12 mt-4">
                <label for="exam_request_obs_store" class="form-label">Observação geral</label>
                <textarea class="form-control form-control-solid"
                  id="exam_request_obs_store" rows="3"
                  v-model="formStore.exam_request_obs" placeholder="Ex.: Hipótese diagnóstica ou orientação que deve constar no pedido"></textarea>
                <small class="text-muted d-block mt-2">Esta observação será exibida no pedido de exames.</small>
              </div>
            </template>
          </div>
          <div class="modal-footer">
            <button type="button" class="prescription-create__chip" data-bs-dismiss="modal">Fechar</button>
            <button v-if="!fromPrevious" type="submit" class="prescription-create__chip prescription-create__chip--primary" :disabled="creating">
              {{ creating ? 'Cadastrando...' : 'Cadastrar' }}
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
  </Teleport>

  <PdfViewer :id="'modal_pdf_viewer_exam_' + this.modalRecordId"
             :pdf-source="this.pdfSource"
             :file-name="this.fileName"
             :signed="this.signed"
             :key="'Exam:'+ modalRecordId"
             :delivery="documentsDelivery"
             @edit-contact="openPatientContact"/>

  <SelectCertifier :id="'modal_certifier_exam'  + this.modalRecordId"
                   :certifiers="this.certifiers"
                   :key="'ExamCertifier:'+ modalRecordId"
                   @onSelect="printExams"/>


  <SaveAsModelModal :id-modal="'modal_save_exam_model_' + modalRecordId"
                    title="Salvar pedido como modelo"
                    hint="O modelo fica disponível na criação de novos pedidos, já com os exames."
                    :summary="saveAsModelSummary"
                    :suggestion="saveAsModelSuggestion"
                    :saving="savingAsModel"
                    @save="saveExamRequestAsModel"/>

</template>

<script>
import { taskDocumentParams, taskDocumentLinked } from '@/views/tasks/taskDocumentContext';
import SelectUbbi from "@/components/SelectUbbi.vue";
import PreviousDocumentPicker from '../shared/PreviousDocumentPicker.vue';
import http from "../../../helpers/http";
import Alert from "../../../helpers/alert";
import OS from "../../../helpers/os";
import Base64 from "../../../helpers/base64";
import ExamRequestItems from "./ExamRequestItems";
import DraftExamComposer from "../shared/DraftExamComposer.vue";
import PdfViewer from "../shared/PdfViewer";
import Config from "../../../config";
import SelectCertifier from "../../../components/SelectCertificator";
import SaveAsModelModal from "../../../components/SaveAsModelModal";
import documentsDelivery from "../shared/documentsDelivery";
import {confirmarAssinaturaSemSelo} from "../shared/signatureSealWarning";

export default {
  name: "ExamRequest",
  emits: ['signed', 'onModelSaved', 'edit-patient-contact'],
  mixins: [documentsDelivery],
  components: {
    SelectUbbi,
    PreviousDocumentPicker,
    ExamRequestItems,
    DraftExamComposer,
    PdfViewer,
    SelectCertifier,
    SaveAsModelModal,
  },
  props: {
    taskContext: { type: Object, default: null },
    schedule: Object,
    medicalRecord: Object,
    examProtocols: Array,
    readonly: Boolean,
    certifiers: Array,
  },
  data() {
    return {
      fromPrevious: false,
      currentExamRequestId: '',
      examRequests: [],
      creating: false,
      draftExams: [],
      formStore: {
        id_medrec: '',
        exam_request_name: '',
        id_exam_prot: '',
        exam_request_obs: '',
      },
      formStoreErrors: [],
      saveAsModelSource: null,
      saveAsModelSuggestion: '',
      saveAsModelSummary: '',
      savingAsModel: false,
      messagesGenerateExam: {
        message: '',
        image: '',
        showBtnClose: false,
      },
      pdfSource: '',
      fileName: '',
      signed: false,
      selectedExamRequest: '',
    }
  },
  computed: {
    modalRecordId() { return this.medicalRecord.id_medrec + (this.taskContext ? '_task_' + this.taskContext.id : ''); },
    userAuth() {
      return this.$store.state.auth.user;
    },
    place() {
      return this.$store.state.auth.place;
    },
  },
  mounted() {
    this.examRequests = this.taskContext ? [] : (this.medicalRecord.exam_requests || this.medicalRecord.examRequests || []);
    if (this.taskContext) {
      this.getExamRequests().then(() => {
        if (!this.examRequests.length && !this.taskContext.quick) this.$nextTick(() => bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_store_exam_request_' + this.modalRecordId)).show());
      }).catch(error => Alert.toastError(error.response?.data?.message || 'Não foi possível carregar os documentos.'));
    } else {
      this.getExamRequests();
    }
  },
  methods: {
    documentDomId(id) { return id + (this.taskContext ? '_task_' + this.taskContext.id : ''); },
    onModelChange() {
      const model = this.examProtocols?.find((protocol) => protocol.id_exam_prot == this.formStore.id_exam_prot);
      this.formStore.exam_request_name = model?.exam_prot_name ?? '';
      if (!model) {
        return;
      }

      http.get(`/professionals/${this.schedule.id_prof}/exam-protocols/${model.id_exam_prot}/exams`).then((response) => {
        this.draftExams = response.data ?? [];
      }).catch(() => {
        this.draftExams = [];
      });
    },
    resetCreateForm() {
      this.fromPrevious = false;
      this.creating = false;
      this.draftExams = [];
      this.formStoreErrors = [];
      this.formStore = {
        id_medrec: '',
        exam_request_name: '',
        id_exam_prot: '',
        exam_request_obs: '',
      };
      this.$refs.examComposer?.reset?.();
    },
    closeCreateModal() {
      bootstrap.Modal.getInstance(document.getElementById('modal_store_exam_request_' + this.modalRecordId))?.hide();
    },
    async onPreviousCopied(result) {
      await this.getExamRequests();
      this.closeCreateModal();
      this.fromPrevious = false;
      if (result?.certifier) {
        const copy = this.examRequests.find(item => Number(item.id_exam_request) === Number(result.document.id_exam_request));
        if (!copy) return;
        await this.$nextTick();
        this.selectedExamRequest = copy;
        await this.printExams(result.certifier);
      }
    },
    examsUrl(examRequest) {
      return `/professionals/${this.medicalRecord.id_prof}/patients/${this.medicalRecord.id_patient}/medical-records/${examRequest.id_medrec}/exam-requests/${examRequest.id_exam_request}/exams`;
    },
    openSaveAsModel(examRequest) {
      this.saveAsModelSource = examRequest;
      this.saveAsModelSuggestion = examRequest.exam_request_name ?? '';
      this.saveAsModelSummary = '';

      http.get(this.examsUrl(examRequest)).then((response) => {
        const total = (response.data ?? []).length;
        this.saveAsModelSummary = total === 1
            ? '1 exame será salvo no modelo.'
            : `${total} exames serão salvos no modelo.`;
      }).catch(() => {
        this.saveAsModelSummary = '';
      });
    },
    saveExamRequestAsModel(name) {
      const examRequest = this.saveAsModelSource;
      if (!examRequest) {
        return;
      }

      this.savingAsModel = true;

      http.get(this.examsUrl(examRequest)).then((response) => {
        const exams = (response.data ?? []).map((exam) => ({id_exam: exam.id_exam}));

        if (exams.length === 0) {
          this.savingAsModel = false;
          Alert.toastError('Adicione ao menos um exame antes de salvar como modelo.');

          return;
        }

        return http.post(`/professionals/${this.medicalRecord.id_prof}/exam-protocols`, {
          exam_prot_name: name,
          active: true,
          exams,
        }).then(() => {
          Alert.toastSuccess('Modelo salvo. Ele já aparece na criação de novos pedidos.');
          this.$emit('onModelSaved');
          bootstrap.Modal.getInstance(document.getElementById('modal_save_exam_model_' + this.modalRecordId)).toggle();
        });
      }).catch((e) => {
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível salvar o modelo.');
      }).finally(() => {
        this.savingAsModel = false;
      });
    },
    showSelectCertifier(examRequest) {

      this.selectedExamRequest = examRequest;

      if (!examRequest.exam_request_signed) {
        let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_certifier_exam'  + this.modalRecordId));
        modal.toggle();
      } else {
        this.printExams(null);
      }
    },
    async printExams(certifier) {

      let examRequest = this.selectedExamRequest;

      const seguir = await confirmarAssinaturaSemSelo({
        generated: examRequest?.exam_request_generated,
        signed: examRequest?.exam_request_signed,
        certifier,
      });

      if (!seguir) {
        return;
      }

      let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_print_exam_' + this.documentDomId(examRequest.id_exam_request)));
      modal.toggle();

      this.messagesGenerateExam = {
        message: 'Gerando exame, por favor, aguarde...',
        image: require('@/assets/mp4/8558-floating-document.mp4'),
        showBtnClose: false,
      }

      const taskParams = taskDocumentParams(this.$route, 'exam_request', this.medicalRecord, this.taskContext);
      return http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests/${examRequest.id_exam_request}/print`, { ...taskParams, certifier_id: certifier?.id ?? null }).then(async (response) => {
        taskDocumentLinked(taskParams);
        await new Promise(r => setTimeout(r, 600));

        this.getExamRequests();

        this.messagesGenerateExam = {
          message: 'Baixando pedido de exame ...',
          image: require('@/assets/mp4/97795-download-green.mp4'),
          showBtnClose: false,
        }

        let data = response.data;

        await new Promise(r => setTimeout(r, 600));

        if (data.exam_request.exam_request_generated && (data.exam_request.exam_request_signed || !certifier || certifier?.id === null || certifier?.id === "none")) {
          return this.showPdfViewer( `data:application/pdf;base64,${data.file_base64}`, data.authenticator.file.file_name, data.exam_request.exam_request_signed, modal);
        }

        if (certifier.id === "vidaas") {
          await this.signCloud(examRequest, certifier, modal,  data.authenticator.file.file_name);
        }

        if (certifier.id === "token") {
          modal.toggle();
          await this.signToken(data, examRequest, modal);
        }
      }).catch((e) => {
        this.messagesGenerateExam = {
          message: e.response.data,
          image: require('@/assets/mp4/4386-connection-error.mp4'),
          showBtnClose: true,
        }
      });
    },
    async signCloud(examRequest, certifier, modal, filename) {

      this.messagesGenerateExam = {
        message: 'Assinando digitalmente...' + '\n' +
            'Para concluir, caso seja solicitado, autorize a transação no aplicativo em seu celular.\n' +
            'A liberação do seu celular é válida por 24 horas. Dentro desse período, você não precisará repetir esta etapa.',
        image: require('@/assets/mp4/signing.mp4'),
        showBtnClose: false,
        loop: true,
      };

      await http.post(`${certifier.url}/exam/${examRequest.id_exam_request}`).then(async (response) => {
        let data = response.data;
        this.getExamRequests();
        this.showPdfViewer(`data:application/pdf;base64,${data.base64_signed}`, filename, true, modal);
      }).catch((e) => {
        modal.toggle();
        Alert.toastError('Erro ao assinar documento');
        this.messagesGenerateExam = {
          message: e.response.data,
          image: require('@/assets/mp4/4386-connection-error.mp4'),
          showBtnClose: true,
        }
      });
    },
    async signToken(fileToBeSign, examRequest, modal) {
      if (!window.WebSocket) {
        Alert.toastError('Seu navegador não tem suporte a conexão websocket.');
        return;
      }

      let certificatePassword = sessionStorage.getItem('certificate_password');
      if (!certificatePassword) {

        const { value: password } = await Swal.fire({
          title: 'Senha do certificado',
          input: 'text',
          inputLabel: 'Informe a senha',
          confirmButtonText: 'Assinar',
          cancelButtonText: 'Cancelar',
          confirmButtonColor: '#780f5a',
          showCancelButton: true,
          inputValidator: (value) => {
            if (!value) {
              return 'Informe a senha do certificado digital!'
            }
          }
        });

        if (password)
          certificatePassword = Base64.encode(password);

        if (!certificatePassword)
          return;
      }

      modal.toggle();

      this.messagesGenerateExam = {
        message: 'Assinando digitalmente ...',
        image: require('@/assets/mp4/signing.mp4'),
        showBtnClose: false,
        loop: true,
      };

      let certificate = null;

      if (OS.getOS() === 'Windows') {
        let wsCertificates = new WebSocket(Config.protocol_ws + '://localhost:8044/certificates');
        wsCertificates.onopen = () => {
          wsCertificates.send('1');
        }

        wsCertificates.onmessage = async (event) => {
          let certificatesRaw = JSON.parse(event.data);
          wsCertificates.close(1000);

          if (certificatesRaw.length <= 0) {
            this.messagesGenerateExam.showBtnClose = true;
            Alert.toastError('Nenhum certificado encontrado.');
            return;
          }

          let certificates = certificatesRaw.sort((certificateOne, certificateTwo) => {
            let expiryDateOne = new Date(certificateOne.expiryDate.toUpperCase().replace("BRT", "GMT-0300"));
            let expiryDateTwo = new Date(certificateTwo.expiryDate.toUpperCase().replace("BRT", "GMT-0300"));

            return expiryDateTwo - expiryDateOne;
          });

          if (certificates.length === 1) {
            certificate = certificates.alias;
            return;
          }

          let alias = certificates.map(a => a.alias);

          const { value: aliasSelected } = await Swal.fire({
            title: 'Certificados instalados',
            input: 'select',
            inputOptions: {
              alias
            },
            inputPlaceholder: 'Selecione um certificado',
            inputValidator: (value) => {
              return new Promise((resolve) => {
                if (value !== null) {
                  resolve();
                } else {
                  resolve('Selecione um certificado.');
                }
              });
            }
          });

          certificate = aliasSelected;
        }

        wsCertificates.onerror = () => {
          this.messagesGenerateExam.showBtnClose = true;
          Swal.fire({
            title: "Opsss",
            text: "Não conseguimos identificar o Assinador Ubbimed instalado.",
            icon: "warning",
            confirmButtonText: 'OK',
            confirmButtonColor: '#780f5a',
          }).then(() => {
            window.open('/assinador/download')
          });
        }
      }

      let connectedPdfSign = false;
      let wsSignConnection = new WebSocket(Config.protocol_ws + '://localhost:8044/pdf/sign');
      wsSignConnection.onopen =  () => {
        connectedPdfSign = true;
        let dataToBeSign = {
          certificate_pfx_as_base64: null,
          certificate_password: Base64.decode(passwordCertificate),
          reason: 'Assinatua de documentos Ubbimed.',
          location: this.place.place_name,
          contact: `${this.userAuth.user_name} <${this.userAuth.user_email}>`,
          certificate_alias: certificate,
          file_id: examRequest.id_exam_request,
          file_as_base64: fileToBeSign.file_base64
        };

        wsSignConnection.send(JSON.stringify(dataToBeSign));
      }

      wsSignConnection.onmessage = (message) => {
        let responseSignature = JSON.parse(message.data);
        const file = Base64.str2Blob(responseSignature.file_signed_as_base64)
        const formData = new FormData();
        formData.append('file', file, 'file.pdf')

        let url = `/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests/${examRequest.id_exam_request}/upload-signed`;
        http.post(url, formData).then((response) => {
          Alert.toastSuccess('Assinatura realizada com sucesso.')

          this.showPdfViewer(`data:application/pdf;base64,${data.file_base64}`,  data.authenticator.file.file_name, true, modal);

          if (!sessionStorage.getItem('certificate_password')) {
            Swal.fire({
              text: 'Quer salvar a senha para nas próximas assinaturas?',
              icon: 'success',
              showCloseButton: true,
              showCancelButton: true,
              confirmButtonText: 'Sim, salvar senha',
            }).then(async (result) => {
              if (result.isConfirmed) {
                sessionStorage.setItem('certificate_password', passwordCertificate);
              }
            });
          }
        });

        wsSignConnection.close(1000);
      }

      wsSignConnection.onerror = (error) => {
        Swal.close();
        if (connectedPdfSign) {
          this.messagesGenerateExam = {
            message: 'Ocorreu um erro inesperado com o assinador Ubbimed. (' + error.code + ')',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        } else {
          this.messagesGenerateExam = {
            message: 'Não foi possível estabelecer uma conexão com o assinador. ' +
                '<br><br>Verifique se o assinador Ubbimed está instalado ou se o mesmo está em execução na sua máquina.',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        }
      }

      wsSignConnection.onclose = (error) => {
        if (error.code === 1006) {
          this.messagesGenerateExam = {
            message: 'Falha na comunição com o assinador.',
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        } else if (error.code === 1011) {
          this.messagesGenerateExam = {
            message: error.reason,
            image: require('@/assets/mp4/4386-connection-error.mp4'),
            showBtnClose: true,
            loop: true,
          }
        }
      }
    },
    getExamRequests() {
      if (this.schedule == null)
        return;

      return http.get(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests`).then((response) => {
        this.examRequests = this.taskContext ? response.data.filter(item => Number(item.id_task_origin) === Number(this.taskContext.id)) : response.data;
      });
    },
    submitFormStore() {
      if (this.fromPrevious || this.creating) return;

      const name = ((this.formStore.exam_request_name ?? '').trim()
          || this.draftExams[0]?.exam_name
          || 'Pedido de exames').slice(0, 100);

      this.formStoreErrors = [];
      this.creating = true;

      const payload = {
        ...taskDocumentParams(this.$route, 'exam_request', this.medicalRecord, this.taskContext),
        id_medrec: this.medicalRecord.id_medrec,
        exam_request_name: name,
        exam_request_obs: this.formStore.exam_request_obs || null,
      };
      if (this.formStore.id_exam_prot && this.draftExams.length === 0) {
        payload.id_exam_prot = this.formStore.id_exam_prot;
      }

      const url = `/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests`;
      http.post(url, payload).then((response) => {
        const examRequest = response.data;
        if (!examRequest?.id_exam_request || this.draftExams.length === 0) {
          return Promise.resolve(examRequest);
        }

        return this.draftExams.reduce((chain, exam) => chain.then(() => {
          return http.post(`${url}/${examRequest.id_exam_request}/exams`, {id_exam: exam.id_exam});
        }), Promise.resolve()).then(() => examRequest);
      }).then(() => {
        this.getExamRequests();
        Alert.toastSuccess(this.draftExams.length
            ? 'Pedido cadastrado com os exames.'
            : 'Pedido cadastrado com sucesso.');
        this.resetCreateForm();
        this.closeCreateModal();
      }).catch((e) => {
        this.getExamRequests();
        Alert.toastError(e.response?.data?.message ?? e.response?.data ?? 'Não foi possível cadastrar o pedido.');
        if (e.response?.data?.errors) {
          this.formStoreErrors = e.response.data.errors;
        }
      }).finally(() => {
        this.creating = false;
      });
    },
    deleteExamRequest(examRequestId) {
      Swal.fire({
        title: 'Heeyy',
        text: "Tem certeza que deseja remover o pedido de exame?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, remover!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.delete(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests/${examRequestId}`).then(_ => {
            this.getExamRequests();
            Alert.toastSuccess("Pedido excluÍdo com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    reopenExamRequest(examRequestId) {
      Swal.fire({
        title: 'Heeyy',
        text: "A reabertura irá cancelar o PDF que já foi gerado. Tem certeza que deseja reabrir o pedido de exame?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'Sim, reabrir!',
        cancelButtonText: 'Cancelar',
        customClass: {
          confirmButton: "btn btn-danger",
          cancelButton: 'btn btn-secundary'
        }
      }).then((result) => {
        if (result.isConfirmed) {
          http.post(`/professionals/${this.schedule.id_prof}/patients/${this.schedule.id_patient}/medical-records/${this.medicalRecord.id_medrec}/exam-requests/${examRequestId}/reopen`).then(_ => {
            this.getExamRequests();
            Alert.toastSuccess("Pedido de exame reaberto com sucesso.");
          }).catch(e => {
            Alert.toastError(e.response.data);
          })
        }
      });
    },
    showPdfViewer(pdfSource,fileName, signed, modalOri) {
      this.loadDocumentsDelivery();

      this.pdfSource = pdfSource;
      this.fileName = fileName;
      this.signed = signed;
      if (signed) this.$emit('signed');
      modalOri.toggle();
      let modal = bootstrap.Modal.getOrCreateInstance(document.getElementById('modal_pdf_viewer_exam_' + this.modalRecordId));
      modal.toggle();
    },
  },
}
</script>

<style scoped>

/* Observacao do pedido: antes era um <b> solto colado na listagem, sem
   espacamento e sem indicacao do que era o texto. */
.exam-request-obs {
  display: flex;
  align-items: flex-start;
  gap: 8px;
  margin-bottom: 10px;
  padding: 8px 12px;
  border-radius: 8px;
  background: #f8f9fa;
  border-left: 3px solid #e4e6ef;
  color: #495057;
  font-size: 0.875rem;
  line-height: 1.4;
  white-space: pre-wrap;
  overflow-wrap: break-word;
}

/* Card principal de exame */
.exam-card {
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-left: 3px solid #780f5a;
  border-radius: 12px;
  overflow: hidden;
  margin-bottom: 20px;
  transition: border-color 0.2s ease;
}

.exam-card:hover {
  border-color: #dcdcdc;
  border-left-color: #780f5a;
}

/* Header do exame */
.exam-header {
  background: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: all 0.3s ease;
}

.exam-header:hover {
  background: linear-gradient(135deg, #e9ecef 0%, #dee2e6 100%);
  border-bottom-color: #6a0d4e;
}

.exam-title {
  display: flex;
  align-items: center;
  gap: 16px;
  flex: 1;
}

.exam-icon {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.exam-icon .svg-icon {
  color: #6c757d;
}

.exam-info {
  flex: 1;
}

.exam-name {
  color: #495057;
  font-size: 1.3rem;
  font-weight: 700;
  margin: 0 0 8px 0;
}

.exam-status {
  display: flex;
  gap: 8px;
  align-items: center;
}

.status-icon {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 8px;
  padding: 4px 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6c757d;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.status-icon:hover {
  background: #e9ecef;
  transform: scale(1.05);
}

.status-icon.locked {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.status-icon.unlocked {
  background: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.status-icon.pdf {
  background: #f8d7da;
  border-color: #f5c6cb;
  color: #721c24;
}

.status-icon.signed {
  background: #d4edda;
  border-color: #c3e6cb;
  color: #155724;
}

.exam-toolbar {
  background: #f8f9fa;
  border: 1px solid #dee2e6;
  border-radius: 12px;
  padding: 10px;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 40px;
  min-height: 40px;
}

.exam-toolbar:hover {
  background: #e9ecef;
  border-color: #780f5a;
  transform: scale(1.05);
}

.exam-toolbar .svg-icon {
  color: #6c757d;
  font-size: 1.2rem;
}

.exam-toolbar:hover .svg-icon {
  color: #780f5a;
}

/* Toolbar principal */
.card-toolbar {
  background: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 20px 20px 0;
  border-radius: 12px 12px 0 0;
}

.main-actions {
  display: flex;
  gap: 12px;
  flex-wrap: wrap;
}

.main-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 12px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  font-weight: 600;
  font-size: 0.9rem;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #ffffff;
  color: #666666;
}

.main-btn:hover {
  border-color: #780f5a;
  color: #780f5a;
  box-shadow: 0 2px 8px rgba(120, 15, 90, 0.15);
}

.main-btn-primary {
  background: #780f5a;
  color: white;
  border-color: #780f5a;
}

.main-btn-primary:hover {
  background: #6a0d4e;
  border-color: #6a0d4e;
  color: white;
}

.main-btn-success {
  background: #50cd89;
  color: white;
  border-color: #50cd89;
}

.main-btn-success:hover {
  background: #47be7d;
  border-color: #47be7d;
  color: white;
  box-shadow: 0 2px 8px rgba(80, 205, 137, 0.25);
}

/* Ações do exame */
.exam-actions {
  background: #f8f9fa;
  border-bottom: 1px solid #e8e8e8;
  padding: 16px 20px;
}

.action-buttons {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
}

/* Telas estreitas: em linha os botoes quebravam em larguras desiguais, com o
   ultimo sozinho. Em grade eles ficam do mesmo tamanho e alinhados. */
@media (max-width: 767.98px) {
  .action-buttons {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .action-btn {
    justify-content: center;
    text-align: center;
    padding: 10px 12px;
    line-height: 1.25;
  }
}

/* So empilha em uma coluna quando duas nao cabem mais: a 414px quatro botoes
   em coluna gastam meia tela de altura. */
@media (max-width: 359.98px) {
  .action-buttons {
    grid-template-columns: 1fr;
  }
}


.action-btn {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 16px;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  font-weight: 500;
  font-size: 0.85rem;
  transition: all 0.2s ease;
  cursor: pointer;
  background: #ffffff;
  color: #666666;
}

.action-btn:hover {
  border-color: #780f5a;
  color: #780f5a;
  box-shadow: 0 2px 6px rgba(120, 15, 90, 0.15);
}

.action-btn-primary {
  background: #780f5a;
  color: white;
  border-color: #780f5a;
}

.action-btn-primary:hover {
  background: #6a0d4e;
  border-color: #6a0d4e;
  color: white;
}

.action-btn-success {
  background: #50cd89;
  color: white;
  border-color: #50cd89;
}

.action-btn-success:hover {
  background: #47be7d;
  border-color: #47be7d;
  color: white;
  box-shadow: 0 2px 6px rgba(80, 205, 137, 0.25);
}

.action-btn-warning {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-warning:hover {
  background: #e9ecef;
  border-color: #780f5a;
  color: #780f5a;
}

.action-btn-info {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-info:hover {
  background: #e9ecef;
  border-color: #780f5a;
  color: #780f5a;
}

.action-btn-danger {
  background: #f8f9fa;
  color: #6c757d;
  border-color: #dee2e6;
}

.action-btn-danger:hover {
  background: #e9ecef;
  border-color: #dc3545;
  color: #dc3545;
}

/* Botão de impressão destacado */
.action-btn-print {
  color: #780f5a;
  border: 1px solid #780f5a;
}

.action-btn-print:hover {
  color: #6a0d4e;
  border-color: #6a0d4e;
}

/* Botão de exclusão destacado */
.action-btn-delete {
  color: #dc3545;
  border: 1px solid #dc3545;
}

.action-btn-delete:hover {
  color: #c82333;
  border-color: #c82333;
}

/* Botão de reabertura destacado */
.action-btn-reopen {
  color: #0d6efd;
  border: 1px solid #0d6efd;
}

.action-btn-reopen:hover {
  color: #0b5ed7;
  border-color: #0b5ed7;
}

/* Estado vazio */
.empty-state {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 300px;
  padding: 40px 20px;
  background: #f8f9fa;
  border-radius: 12px;
  margin: 20px 0;
}

.empty-state-content {
  text-align: center;
  max-width: 400px;
}

.empty-state-icon {
  margin-bottom: 24px;
  opacity: 0.6;
  animation: float 3s ease-in-out infinite;
}

.empty-state-title {
  color: #780f5a;
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0 0 16px 0;
  text-shadow: 0 2px 4px rgba(120, 15, 90, 0.1);
}

.empty-state-description {
  color: #6c757d;
  font-size: 1rem;
  line-height: 1.6;
  margin: 0;
  font-weight: 400;
}

/* Animação flutuante para o ícone */
@keyframes float {
  0%, 100% {
    transform: translateY(0px);
  }
  50% {
    transform: translateY(-10px);
  }
}
</style>
<style scoped src="../shared/prescriptionCreate.css"></style>
